'use strict';

var _ = require('lodash');

/** @OverlaySelectorController */
function OverlaySelectorController ($scope, $timeout, leafletData, Flux, IdentityService, OverlaySelectorActions, sbAuth, Utils) {

  var OverlaySelectorStore = Flux.Store.get('OverlaySelectorStore');
  var SiteStore = Flux.Store.get('SiteStore');
  var MapStore = Flux.Store.get('MapStore');

  //Directive behavior
  this.visible = false;
  this.position = 'center';

  this.filterableOverlays = [];
  this.filteredByCategory = {};
  this.searchTerm = null;

  //data for internal map booster
  this.currentOverlayPreviewMap = {
    id : null,
    center : null,
    defaults : null,
    events : null,
    overlays : null,
    layers : {
      baseLayers : null,
      layers : null
    }
  };


  /**
   * Get when the OverlaySelectorStore changes, and create new filterable list, and triggers the update on the ui
   */
  this._handleStoreChange = function _handleStoreChange () {
    var available = OverlaySelectorStore.get('available');
    var selected = OverlaySelectorStore.get('currentOverlayPreview');

    this.visible = OverlaySelectorStore.get('dialogVisibility');
    // Do not act over the hidden map
    if (!this.visible) {
      return;
    }

    this.availableOverlays = _.indexBy(available, 'id');
    this.filterableOverlays = available.map(function(overlay) {
      overlay.selected = selected && selected.id === overlay.id;
      return overlay;
    });

    // this.filterableOverlays = filterableOverlays;
    this.filteredByCategory = _.groupBy(available, 'category');
    this.currentOverlayPreviewMap = OverlaySelectorStore.get('currentOverlayPreviewMap');

    var currentDataCapture = MapStore.get('dataCapture');

    if (currentDataCapture) {
      //cook object as the map booster is expecting it :S
      currentDataCapture.layers = angular.copy(currentDataCapture.dataCaptureLayers);
      currentDataCapture.layers.forEach(function(layer){
        layer.dataCaptureId = currentDataCapture.id;
        layer.layerId = layer.layerData;
        layer.id = layer.id; // Redundant, but better to be explicit
      });

      this.currentDataCapture = [currentDataCapture];
    }

    if (this.searchTerm === null) {
      this.searchTerm = ''; // trigger first change for ui update
    }

    $timeout(function () { // because angular, thats why!

      leafletData.getMap().then(function (map) {
        map.invalidateSize();
      });

    }, 10, true);

  };

  this.getResourceProxyAuth = function getResourceProxyAuth () {
    var resourceProxyUri = IdentityService.getResourceProxyUri();

    return sbAuth.getToken().then(function (token) {
      return {
        resourceProxyUri: resourceProxyUri,
        token: token
      };
    });
  };

  // Handlers //////////////////////////////////////////////////////////////////

   /**
   * Emit the Flux.Action matching the selected overlay on the list
   */
  this.handleOverlayListItemClick = function handleOverlayListItemClick(data){
    OverlaySelectorActions.OverlayPreviewSelected.dispatch({
      overlay : data
    });
  };

  /**
   * Emit the Flux.Action matching the hide modal intent, and resets the filter
   */
  this.hideModal = function hideModal() {
    OverlaySelectorActions.HideOverlaySelector.dispatch();
    this.searchTerm = ''; //clean filter input on show
  };

  /**
   * Emit the Flux.Action for selecting an overlay to put in the annotation
   */
  this.selectOverlay = function selectOverlay() {
    OverlaySelectorActions.OverlaySelected.dispatch({
      overlay : OverlaySelectorStore.get('currentOverlayPreview')
    });

    this.hideModal();
  };


  /**
   * When the filtered list changes (the booster updates), updates the list of results
   */
  this._handleFiltered = function _handleFiltered() {

    // First load
    if (!this.filtered) {
      return;
    }
    var filtered = []; // list of Overlay objects
    // Fill the Site object list, based on the filtered results id's
    this.filtered.forEach(function(overlay) {
      if (!overlay) {
        return; // Filtered has holes in the array
      }
      filtered.push(this.availableOverlays[overlay.id]);
    }.bind(this));

    // show them in the UI
    if (filtered){
      this.filteredByCategory = _.groupBy(filtered, 'category');
    }else {
      // Maybe show an empty list?
    }

  };

  this._handleFiltered();

  $scope.$watch('overlaySelectorCtrl.filtered', this._handleFiltered.bind(this));
  OverlaySelectorStore.on(OverlaySelectorStore.Events.Changed, this._handleStoreChange.bind(this), $scope);
}

OverlaySelectorController.$inject = ['$scope', '$timeout', 'leafletData', 'sbFlux', 'IdentityService', 'OverlaySelectorActions', 'sbAuth', 'Utils'];
module.exports = OverlaySelectorController;


// WEBPACK FOOTER //
// ./src/app/dash/overlaySelector/OverlaySelectorController.js